import React from "react";
import { format } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/pro-regular-svg-icons";
import { ConfirmationGraphic } from "../NewRequisition/ConfirmationGraphic";
import {
  CfcConfirmationLayout,
  CfcConfirmationMessage,
  CfcConfirmationFieldsGrid,
  CfcConfirmationField,
  CfcConfirmationFieldLabel,
  CfcConfirmationFieldValue,
  CfcConfirmationInfoBanner,
  CfcConfirmationGraphicWrapper,
} from "./CfcConfirmation.styles";

interface CfcConfirmationProps {
  orderNumber: string;
}

const ORDER_DATE_FORMAT = "MM/dd/yyyy";

export const CfcConfirmation = ({
  orderNumber,
}: CfcConfirmationProps): React.ReactElement => (
  <CfcConfirmationLayout>
    <CfcConfirmationMessage>
      Your order has been confirmed and will be processed upon sample receipt.
    </CfcConfirmationMessage>
    <CfcConfirmationFieldsGrid>
      <CfcConfirmationField>
        <CfcConfirmationFieldLabel>Order Date</CfcConfirmationFieldLabel>
        <CfcConfirmationFieldValue>
          {format(new Date(), ORDER_DATE_FORMAT)}
        </CfcConfirmationFieldValue>
      </CfcConfirmationField>
      <CfcConfirmationField>
        <CfcConfirmationFieldLabel>Order Number</CfcConfirmationFieldLabel>
        <CfcConfirmationFieldValue>{orderNumber}</CfcConfirmationFieldValue>
      </CfcConfirmationField>
    </CfcConfirmationFieldsGrid>
    <CfcConfirmationInfoBanner>
      <FontAwesomeIcon icon={faPrint} fontSize={20} />
      <span>
        Please don&apos;t forget to <strong>print</strong> and{" "}
        <strong>attach</strong> the order confirmation to the test kit.
      </span>
    </CfcConfirmationInfoBanner>
    <CfcConfirmationGraphicWrapper aria-hidden="true">
      <ConfirmationGraphic />
    </CfcConfirmationGraphicWrapper>
  </CfcConfirmationLayout>
);
